module.exports = __webpack_public_path__ + "img/f768601.jpg";